import { Button, Drawer, Flex } from 'antd'
import { MutableRefObject, useContext, useEffect, useRef, useState } from 'react'
import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons'
import CatalogBrowserContext, { CatalogBrowserContextWrapper } from '../../../ItemCatalog/CatalogBrowserContext'
import EditorSidebarTabs from '../../../ItemCatalog/EditorSidebarTabs'
import SidebarCatalogBrowser from '../../../ItemCatalog/SidebarCatalogBrowser'
import ReadyToInvoiceContext from '../ReadyToInvoiceContext'
import JobEditor from './JobEditor'
import JobsSection, { JobsMenuScrollState } from './Sidebar/JobsSection'

type SidebarProps = {
  isVisible: boolean
  scrollState: MutableRefObject<JobsMenuScrollState>
  filtersExpanded: boolean
  onFiltersExpandedChange: (expanded: boolean) => void
}

const Sidebar = ({ isVisible, scrollState, filtersExpanded, onFiltersExpandedChange }: SidebarProps) => {
  const { isCatalogBrowserOpen } = useContext(CatalogBrowserContext)
  return <aside style={{ width: 380, flexShrink: 0, overflow: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none', background: '#f0f0f0' }}>
    <EditorSidebarTabs listLabel="Jobs" listIcon={faFileInvoiceDollar} />
    {isCatalogBrowserOpen ? <SidebarCatalogBrowser /> : <JobsSection isVisible={isVisible} scrollState={scrollState} filtersExpanded={filtersExpanded} onFiltersExpandedChange={onFiltersExpandedChange} />}
  </aside>
}

const EditorDrawer = () => {
  const { currentSelection, clearSelection } = useContext(ReadyToInvoiceContext)
  const open = currentSelection !== undefined
  const [filtersExpanded, setFiltersExpanded] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const scrollState = useRef<JobsMenuScrollState>({ top: 0, initialScrollPending: true })
  useEffect(() => {
    if (!open) {
      setIsVisible(false)
      scrollState.current = { top: 0, initialScrollPending: true }
    }
  }, [open])

  return <Drawer
    width="100vw"
    open={open}
    afterOpenChange={setIsVisible}
    onClose={clearSelection}
    maskClosable={false}
    styles={{ header: { display: 'none' }, body: { padding: 0 } }}
    footer={<Flex justify="end" style={{ paddingRight: 75 }}><Button type="primary" onClick={clearSelection}>Close</Button></Flex>}
  >
    {currentSelection && <CatalogBrowserContextWrapper key={currentSelection.jobId} allowDragging={false} showTemplates>
      <Flex style={{ height: '100%' }}>
        <Sidebar isVisible={isVisible} scrollState={scrollState} filtersExpanded={filtersExpanded} onFiltersExpandedChange={setFiltersExpanded} />
        <main style={{ flex: 1, minWidth: 0, background: '#fafafa' }}>
          <JobEditor />
        </main>
      </Flex>
    </CatalogBrowserContextWrapper>}
  </Drawer>
}

export default EditorDrawer
